module.exports = __webpack_public_path__ + "img/电表.c87c25d8.png";